// @ts-ignore
import React, { useEffect, useRef, useState } from 'react';
import {
  select,
  axisBottom,
  stack,
  max,
  scaleLinear,
  axisLeft,
  // @ts-ignore
  axisRight,
  // @ts-ignore
  stackOrderAscending,
  area,
  scalePoint,
  // @ts-ignore
  curveCardinal,
  // @ts-ignore
  svg,
  curveBasis,
  // @ts-ignore
  curveBasisClosed,
  // @ts-ignore
  selectAll,
  // @ts-ignore
  line,
  // @ts-ignore
  on,
  // @ts-ignore
  format,
  // @ts-ignore
  geoMercator,
  curveLinear
} from 'd3';
import 'd3';
import useResizeObserver from './useResizeObserver';
import { get } from 'lodash';

const allColors = {
  base: '#f7f7f7',
  Aluno: '#FFFFFF',
  Escola: '#47BEF3',
  Turma: '#737272',
  DRE: '#B972F1',
  Estado: '#001AFF'
};

const allKeysEnem = ['Grupo 1', 'Grupo 2', 'Grupo 3', 'Grupo 4', 'Grupo 5'];
const nomeDisc = [
  'Linguagens, Códigos e suas Tecnologias',
  'Matemática e suas Tecnologias',
  'Ciências da Natureza',
  'Ciências Humanas',
];

function StackedAreaChart({
  dataDot,
  pontos,
  useBase,
  tipo,
  defaultData,
  disc
}) {
  /* Inicio da função que gera nosso gráfico de área */

  const etapa = [
    '2ºEF',
    '3ºEF',
    '4ºEF',
    '5ºEF',
    '6ºEF',
    '7ºEF',
    '8ºEF',
    '9ºEF',
    '1ªEM',
    '2ªEM',
    '3ªEM'
  ];
  const svgRef = useRef();
  const wrapperRef = useRef();
  const dimensions = useResizeObserver(wrapperRef);
  const id_disc = disc ? disc - 1 : get(dataDot, 'CD_DISCIPLINA') - 1;
  const data = dataDot && dataDot.area_chart_data.background;
  const allKeys = dataDot && dataDot.area_chart_data.allKeys;
  const backgroundColors = dataDot && dataDot.area_chart_data.allColors;
  const titulo = nomeDisc[id_disc];
  const [isAvaliaMt, setIsAvaliaMt] = useState("");

  useEffect(() => {
    setIsAvaliaMt(window.location.host.includes("avaliamt"));
  }, []);

  const keys = tipo && (tipo == 3 && isAvaliaMt) ? allKeysEnem : allKeys;
  const colors = allColors;
  const nr_et = get(dataDot, 'NR_ETAPA');
  if (nr_et <= 9) {
    var cor = 2;
  } else {
    var cor = 3;
  }
  // formatar com um foreach e chablau, resolvido!
  const dataScatter = defaultData
    ? defaultData
    : [
      {
        year: etapa[get(dataDot, 'NR_ETAPA') - cor],
        name: get(dataDot, 'NM_ALUNO'),
        type: 'Aluno',
        nota: parseInt(get(dataDot, 'NT_ALUNO'))
      },
      {
        year: etapa[get(dataDot, 'NR_ETAPA') - cor],
        name: get(dataDot, 'NM_DRE'),
        type: 'DRE',
        nota: parseInt(get(dataDot, 'NT_DRE'))
      },
      {
        year: etapa[get(dataDot, 'NR_ETAPA') - cor],
        name: get(dataDot, 'NM_ESCOLA'),
        type: 'Escola',
        nota: parseInt(get(dataDot, 'NT_ESCOLA'))
      },
      {
        year: etapa[get(dataDot, 'NR_ETAPA') - cor],
        name: 'Rede de ensino',
        type: 'Estado',
        nota: parseInt(get(dataDot, 'NT_REDE'))
      }
    ];

  /* Definição das funçõe utilizadas para a renderização do gráfico */
  useEffect(() => {
    // evento que renderiza os dados no gráfico, nota-se que podemos implementar essa função de adicionar dados no nosso gráfico
    // modelo
    // @ts-ignore
    const svg = select(svgRef.current);
    const { width, height } =
      // @ts-ignore
      dimensions || wrapperRef.current.getBoundingClientRect(); //aparentemente essa parte fala do gráfico

    // stacks / layers
    const stackGenerator = stack().keys(keys);
    //.order(stackOrderAscending);
    // @ts-ignore
    const layers = stackGenerator(data);
    const extent = [
      data && data[0] && data[0].base,
      max(layers, (layer) => max(layer, (sequence) => sequence[1] + sequence.data.base))
    ];

    // scales
    /* aqui definimos como irão funcionar as escalas de x e y, colocando a posição em pixels dos pontos em função das grandezas apresentadas no gráfico */
    const xScale = scalePoint()
      .domain(data.map((d) => d.year))
      .range([0, width]);
    // @ts-ignore
    const yScale = scaleLinear().domain(extent).range([height, 0]);

    // axes
    /* Aqui fazemos as declarações relativas aos eixos do gráfico, onde tudo que está dentro de svg é relativo ao style do elemento */
    const xAxis = axisBottom(xScale);
    svg
      .select('.x-axis')
      .attr('transform', `translate(0, ${height})`)
      // @ts-ignore
      .call(xAxis);
    svg
      .append('text')
      .attr('transform', `rotate(-90)`)
      .attr('dx', `${-height / 2}` + 'px')
      .attr('dy', `-50` + 'px')
      .style('font-family', 'helvetica')
      .style('font-size', '30px')
      .style('text-anchor', 'middle')
      .text('Proficiência');
    // @ts-ignore
    const makeXLines = () => axisBottom().scale(xScale);
    svg
      /* Nessa segunda declaração de estilo, temos as linhas que introduzem as linhas verticais do grid */
      .append('g')
      .attr('class', 'grid')
      // @ts-ignore
      .call(makeXLines().tickSize(height, 0, 0).tickFormat(''))
      .attr('color', '#8B8B8B');

    const yAxis = axisLeft(yScale);
    // @ts-ignore
    svg.select('.y-axis').call(yAxis);

    // @ts-ignore
    const makeYLines = () => axisLeft().scale(yScale);
    svg
      /* Nessa segunda declaração de estilo, temos as linhas que introduzem as linhas horizontais do grid */
      .append('g')
      .attr('class', 'grid')
      // @ts-ignore
      .call(makeYLines().tickSize(-width, 0, 0).tickFormat(''))
      .attr('color', '#8B8B8B');
    svg
      .append('text')
      .attr('transform', ``)
      .attr('dx', `${width / 2}` + 'px')
      .attr('dy', `${height + 60}` + 'px')
      .style('font-family', 'helvetica')
      .style('font-size', '30px')
      .style('text-anchor', 'middle')
      .text('Etapa Escolar');

    /* Em areaGenerator definimos como o gráfico de áreas será gerado a partir dos dados passados em data e pelas escalas definidas anteriormente */
    if (useBase === true) {
      // @ts-ignore
      var areaGenerator = area()
        // @ts-ignore
        .x((sequence) => xScale(sequence.data.year)) //define que a mudança em x é relativa ao elemento date.year do array de dados data
        // @ts-ignore
        .y0((sequence) => yScale(sequence[0] + sequence.data.base)) // define a posição relativa y0 em função do topo o elemento anterior e do elemento de base
        // @ts-ignore
        .y1((sequence) => yScale(sequence[1] + sequence.data.base)) // define a posição relativa y1 em função do topo do elemento anterior e do elemento de dado
        .curve(curveLinear); // define que as variações relativas às mudanças em y serão suavizadas
    } else {
      // @ts-ignore
      var areaGenerator = area()
        // @ts-ignore
        .x((sequence) => xScale(sequence.data.year)) //define que a mudança em x é relativa ao elemento date.year do array de dados data
        .y0((sequence) => yScale(sequence[0] + 100)) // define a posição relativa y0 em função do topo o elemento anterior e do elemento de base
        .y1((sequence) => yScale(sequence[1] + 100)) // define a posição relativa y1 em função do topo do elemento anterior e do elemento de dado
        .curve(curveLinear);
    }
    // rendering
    /* aqui definimos os parametros de style das áreas mostradas no gráfico */
    svg
      .selectAll('.layer')
      .data(layers)
      .join('path')
      .attr('class', 'layer')
      .attr('fill', (layer) => backgroundColors[layer.key])
      // @ts-ignore
      .attr('opacity', (layer) => 0.55)
      // @ts-ignore
      .attr('d', areaGenerator)
      .transition()
      .duration(500);

    /* Aqui, caso seja indicado (essa indicação vem pelas props) plota pontos relativos aos  */
    if (pontos === true) {
      var div = select('body')
        .append('div')
        .attr('class', 'tooltip')
        .style('opacity', 0)
        .style('background-color', '#B8B8B8');
      var line = svg
        .append('line')
        // @ts-ignore
        .attr('x1', xScale(dataScatter && dataScatter[0].year))
        // @ts-ignore
        .attr('x2', xScale(dataScatter && dataScatter[0].year))
        .attr('y1', yScale(dataScatter && dataScatter[0].nota))
        .attr('y2', yScale(dataScatter && dataScatter[0].nota))
        .attr('stroke', 'red')
        .attr('stroke-dasharray', '15')
        .style('opacity', 0.01)
        .style('stroke-width', '2px');

      svg
        .selectAll('indPoints')
        .data(dataScatter)
        .enter()
        .append('circle')
        // @ts-ignore
        .attr('cx', function (d) {
          if (d.year == '2ºEF') {
            if (d.type == 'Aluno') {
              // @ts-ignore
              return xScale(d.year) + 0;
            } else if (d.type == 'DRE') {
              // @ts-ignore
              return xScale(d.year) + 6;
            } else if (d.type == 'Escola') {
              // @ts-ignore
              return xScale(d.year) + 9;
            } else if (d.type == 'Estado') {
              // @ts-ignore
              return xScale(d.year) + 3;
            } else if (d.type == 'Turma') {
              // @ts-ignore
              return xScale(d.year) + 7;
            }
          } else if (d.year == '3ªEM' && (tipo != 3 && isAvaliaMt)) {
            if (d.type == 'Aluno') {
              // @ts-ignore
              return xScale(d.year) - 0;
            } else if (d.type == 'DRE') {
              // @ts-ignore
              return xScale(d.year) - 8;
            } else if (d.type == 'Escola') {
              // @ts-ignore
              return xScale(d.year) - 12;
            } else if (d.type == 'Estado') {
              // @ts-ignore
              return xScale(d.year) - 4;
            } else if (d.type == 'Turma') {
              // @ts-ignore
              return xScale(d.year) - 20;
            }
          } else {
            if (d.type == 'Aluno') {
              // @ts-ignore
              return xScale(d.year) + 0;
            } else if (d.type == 'DRE') {
              // @ts-ignore
              return xScale(d.year) + 6;
            } else if (d.type == 'Escola') {
              // @ts-ignore
              return xScale(d.year) - 12;
            } else if (d.type == 'Estado') {
              // @ts-ignore
              return xScale(d.year) - 6;
            } else if (d.type == 'Turma') {
              // @ts-ignore
              return xScale(d.year) + 12;
            }
          }
        })
        .attr('cy', function (d) {
          if (d.nota > 400 && tipo != 3) {
            return yScale(400);
          } else if (d.nota > 900 && (tipo == 3 && isAvaliaMt)) {
            return yScale(900);
          } else if (d.nota < 100) {
            return yScale(100);
          } else {
            return yScale(d.nota);
          }
        })
        .attr('r', function (d) {
          if (isNaN(d.nota)) {
            return 0;
          } else {
            return 3;
          }
        })
        .style('fill', function (d) {
          return colors[d.type];
        })
        .attr('stroke', 'black')
        .attr('class', 'circle')
        .on('mouseover', function (d, i) {
          line
            .transition()
            .attr('x1', xScale('2ºEF'))
            .duration('550')
            .attr('x2', xScale(i.year))
            .attr('y1', i.nota !== 0 ? yScale(i.nota) : yScale(100))
            .attr('y2', i.nota !== 0 ? yScale(i.nota) : yScale(100))
            .attr('stroke', i.type !== 'Aluno' ? colors[i.type] : 'black')
            .style('opacity', 1.0);
          // @ts-ignore
          if (xScale(i.year) >= xScale('8ºEF')) {
            // @ts-ignore
            select(this).transition().duration('100').attr('r', 8);
            div
              .transition()
              .duration(100)
              .style('opacity', 0.8)
              .style('background-color', colors[i.type])
              .style('color', i.type === 'Aluno' ? 'black' : colors['Aluno']);
            div
              .html(i.name + ': ' + i.nota.toFixed(2))
              .style('font-family', 'helvetica')
              .style('font-size', '15px')
              .style(
                'left',
                // @ts-ignore
                d.clientX - div._groups[0][0].offsetWidth + 'px'
              )
              .style(
                'top',
                // (i.nota <= 100 ? d.layerY + 170 : d.layerY + 200)
                d.pageY + 'px'
              )
              .attr('color', '#B8B8B8');
          } else {
            // @ts-ignore

            select(this).transition().duration('100').attr('r', 8);
            div
              .transition()
              .duration(100)
              .style('opacity', 0.8)
              .style('background-color', colors[i.type])
              .style('color', i.type === 'Aluno' ? 'black' : colors['Aluno']);
            div
              .html(i.name + ': ' + i.nota.toFixed(2))
              .style('font-family', 'helvetica')
              .style('font-size', '15px')
              .style('left', d.screenX + 10 + 'px')
              .style(
                'top',
                // (i.nota < 101 ? d.layerY + 170 : d.layerY + 200)
                d.pageY + 'px'
              )
              .attr('color', '#B8B8B8');
          }
        })
        // @ts-ignore
        .on('mouseout', function (d, i) {
          line
            .transition()
            .duration('550')
            .attr('x1', xScale(i.year))
            .attr('x2', xScale(i.year))
            .attr('y1', yScale(i.nota))
            .attr('y2', yScale(i.nota))
            .attr('stroke', 'red')
            .style('opacity', 0.01);
          // @ts-ignore
          select(this).transition().duration('200').attr('r', 3);
          // @ts-ignore
          div.transition().duration('200').style('opacity', 0);
        });
    }
  }, [colors, data, dimensions, keys]);
  return (
    <div style={{ minWidth: '100%' }}>
      <div
        style={{ textAlign: 'center', marginTop: '2rem', marginBottom: '2rem' }}
      >
        <h1 style={{ fontSize: '23px' }}>{titulo.toLocaleUpperCase()}</h1>
      </div>
      <div
        // @ts-ignore
        ref={wrapperRef}
        style={{ marginBottom: '3rem' }}
      >
        <svg
          // @ts-ignore
          ref={svgRef}
          style={{ height: '500px' }}
        >
          <g className="x-axis" />
          <g className="y-axis" />
        </svg>
      </div>
      <div
        className="fields"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        {keys.map((key) => (
          <div
            style={{
              position: 'relative',
              height: '70px',
              justifyContent: 'space-between'
            }}
          >
            <div
              // @ts-ignore
              key={keys}
              className="field"
              style={{
                position: 'relative',
                bottom: '-100%',
                display: 'flex',
                fontFamily: 'helvetica',
                justifyContent: 'space-between'
              }}
            >
              <div
                style={{
                  height: '16px',
                  width: '16px',
                  fontSize: '14px',
                  fontWeight: 500,
                  background: backgroundColors[key],
                  borderRadius: '2px',
                  fontFamily: 'Public Sans',
                  marginLeft: '1rem',
                  marginTop: '3px'
                }}
              />
              <label
                htmlFor=" o"
                // @ts-ignore
                height="20px"
                style={{ display: 'flex', fontFamily: 'helvetica' }}
              ></label>
              <label
                htmlFor={key}
                style={{
                  // @ts-ignore
                  x: '30%',
                  color: '#2b2b2b'
                }}
              >
                {key}
              </label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default StackedAreaChart;
